// COS-BRIEF-RULES: `/c/{slug}/briefs/{id}`, a brief or Chief of Staff report sent to you, in full
// (where its inbox item opens).
import { createRoute } from "@tanstack/react-router";
import { BriefReportPage } from "../features/briefs/brief-report-page";
import { useCompany } from "../features/use-feature";
import { companyRoute } from "./c.$slug";

export const briefReportRoute = createRoute({
  getParentRoute: () => companyRoute,
  path: "briefs/$id",
  component: function BriefReport() {
    const { api } = briefReportRoute.useRouteContext();
    const { id } = briefReportRoute.useParams();
    const company = useCompany();
    return <BriefReportPage key={id} api={api} co={company.id} id={id} />;
  },
});
